<template>
  <v-app>
    <div class="mx-auto my-auto" v-if="loading">
      <RotateLoader color="#2976D2" />
    </div>
    <router-view v-if="!loading" />
  </v-app>
</template>

<script>
import RotateLoader from "vue-spinner/src/RotateLoader.vue";
import i18n from "./plugins/i18n";

export default {
  computed: {
    loading() {
      return this.$store.getters.loading;
    },
    language() {
      return i18n.locale;
    },
    placeConfig() {
      return this.$store.getters.placeConfig;
    },
  },
  components: {
    RotateLoader,
  },

  mounted() {},

  // watch if channge
  watch: {
    placeConfig() {
      const urlParams = new URLSearchParams(window.location.search);
      const languageParams = urlParams.get("language");

      const placeConfigLanguageList = this.placeConfig.languages || [];
      const isArabicLanguage =
        languageParams === "ar" && placeConfigLanguageList.includes("ar");
      const defaultLanguage = "tr";
      const fallbackLanguage = "en";

      let language = fallbackLanguage;

      // ** change the directionm to rtl if the language is arabic
      this.$vuetify.rtl = isArabicLanguage;

      // ** change the font based on the language
      if (isArabicLanguage) {
        import("./assets/styles/arabic-fonts.css");
      } else {
        import("./assets/styles/main-fonts.css");
      }

      // ** change the language i18n
      if (placeConfigLanguageList) {
        if (
          languageParams &&
          placeConfigLanguageList.includes(languageParams)
        ) {
          language = languageParams;
        } else if (placeConfigLanguageList.includes(defaultLanguage)) {
          language = defaultLanguage;
        }
      } else {
        language = defaultLanguage;
      }

      localStorage.setItem("language", language);
      i18n.locale = language;
    },
  },
};
</script>
<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
